module.exports = __webpack_public_path__ + "img/smartmockups_krhr0ue0.151a96bc.jpg";